import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { MarkupAction } from '../markup.action';
import { MarkupTranslator } from '../markup.translator';

type IDependencies = IClientApiDependencySegment;

export const loadMarkupEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(MarkupAction.load.started),
  switchMap((params) => dependencies.api.getMarkupSymbol(params).pipe(
    mergeMap((response) => [
      MarkupAction.load.done({ params, result: MarkupTranslator.fromApiSymbolDetails(response) }),
    ]),
    catchApiError((error) => [
      MarkupAction.load.failed({ params, error }), createApiErrorNotification(error),
    ]),
  )),
);
